import React from "react";
import {Box} from "@mui/material";
import NotInformation from "../../../../../components/NotInformation";
import routes from "../../../../../Routes/routes";
import {getUrlParameters} from "../../External/Model/Model";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {PUBLIC_SEARCH_USERS_BY_USER_TYPE} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {isEmailFormat, userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";
import {useParams} from "react-router-dom";
import CustomSearch from "../../../../../components/SearchSimples/CustomSearch";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

const FindVisitorForm = ({ t, navigate, visitorList, setVisitorList, emptyFields, isValidEmail, setIsValidEmail, email, setEmail }) => {
    const { eventId } = useParams();
    const title = eventId ? "": "find_myself";

    return (
        <>
            <Box className={`col-12 mb-4 text-center ${eventId ? 'mt-3' : ''}`}>
                <p className={`fs-24-to-18 ibl-font-w-600 font-color-general-950 text-capitalize`}>{t(title)}</p>
            </Box>
            <Box className='col-12 px-0'>
                { eventId ?
                    <CustomSearch
                        id={"txt_fvf_enter_email"}
                        label={'enter_your_email'}
                        value={email}
                        setValue={setEmail}
                        onChange={(e) => {
                            const value = e.target.value;
                            if(!value){
                                setIsValidEmail(true);
                            }else{
                                setIsValidEmail(isEmailFormat(value));
                            }
                            setEmail(value);
                        }}
                        onReset={()=> {
                            setEmail("");
                            setIsValidEmail(true);
                        }}
                        emptyFields={emptyFields}
                        isValid={isValidEmail}
                        isValidText={'email_format_invalid'}
                        required={true}
                        showCounter={true}
                        length={64}
                    />
                    :
                    <CustomAddChipSearch
                        autocompleteId={'slt_fvf_visitor'}
                        buttonId={'btn_fvf_visitor'}
                        selectedList={visitorList}
                        setSelectedList={setVisitorList}
                        userTypeIdsSearch={[USER_TYPE_MODEL.VISITOR]}
                        disabled={false}
                        label="search_by_name_email_or_phone"
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        hideButton={true}
                        keyId={"userId"}
                        showRenderOption={true}
                        maxLength={1}
                        helperText={t("press_enter_to_search_for_the_name_email_phone")}
                        noOptionsCard={
                            <NotInformation
                                card={false}
                                text={t('we_could_not_find_your_profile')}
                                showButton={true}
                                buttonId={'btn_fvf_link_create'}
                                buttonOnclick={() =>   {
                                    navigate(getUrlParameters({
                                        url: routes.qrRequestAccess.findMySelfCreateVisitor
                                    }))
                                }}
                                buttonTrans={'create_your_profile'}
                            />
                        }
                        api={PUBLIC_SEARCH_USERS_BY_USER_TYPE}
                        onlyOnKeyDown={true}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        Icon={PersonChipBlack}
                    />
                }
            </Box>
        </>
    );
};
export default FindVisitorForm
